import type { ModalProps } from "antd";
import { Input } from "antd";
import { type FC, type KeyboardEventHandler, useState } from "react";
import { useSelector } from "react-redux";
import { Button } from "@/shared/MiButton";
import Modal from "@/shared/Modal";
import type { RootState } from "../WellLoggingOperations/types";
import { downloadSvg, useGeoData } from "./utils";

export const ExportModal: FC<ModalProps> = (props) => {
	const handleKeyDown: KeyboardEventHandler<HTMLElement> = (e) => {
		if (e.key === "Enter") {
			props.onClose?.({} as React.MouseEvent<HTMLButtonElement>);
		}
	};

	const { min, max } = useSelector((store: RootState) => store.geoTest);

	const [start, setStart] = useState<number | null>(null);
	const [stop, setStop] = useState<number | null>(null);
	const { divColumnsBodyRef, divColumnsHeaderRef } = useGeoData();

	if (!min || !max) {
		return null;
	}

	const handleOk = () => {
		console.log(divColumnsHeaderRef, divColumnsBodyRef);

		void downloadSvg(
			divColumnsHeaderRef,
			divColumnsBodyRef,
			(start ?? min) - min,
			(stop ?? max) - min,
			`Геологические профиля(${Math.round(start ?? min)}-${Math.round(stop ?? max)}).svg`,
		);
		props.onOk?.({} as React.MouseEvent<HTMLButtonElement>);
	};

	return (
		<Modal {...props}>
			<div className="flex h-full flex-col p-2 text-xs font-semibold pt-0">
				<div className="h-full  w-full p-2">
					<div className="flex items-center">
						От:{" "}
						<Input
							type="number"
							className="!ml-4"
							value={start ?? ""}
							status={start && min > start ? "error" : ""}
							onChange={(e) => {
								setStart(Number(e.target.value));
							}}
						/>
					</div>
					<div className="mt-4 flex items-center">
						До:{" "}
						<Input
							type="number"
							className="!ml-4"
							value={stop ?? ""}
							status={stop && max < stop ? "error" : ""}
							onChange={(e) => {
								setStop(Number(e.target.value));
							}}
						/>
					</div>
				</div>
				<div className="flex items-center justify-end mt-2">
					<Button className="mr-2" onClick={props.onCancel}>
						Отменить
					</Button>
					<Button
						onKeyDown={handleKeyDown}
						type="primary"
						onClick={handleOk}
						disabled={
							!!(
								(stop && max < stop) ||
								(start && min > start) ||
								(start && stop && start > stop)
							)
						}
					>
						Экспорт svg
					</Button>
				</div>
			</div>
		</Modal>
	);
};
